import { combineReducers } from 'redux';
import { mapObjectToList } from '../utils';

const byId = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'STORE_RESOURCE_SUCCESS':
    case 'STORE_RESOURCE_CREATE_SUCCESS':
    case 'STORE_RESOURCE_UPDATE_SUCCESS': {
      return {
        ...state,
        ...payload.entities.price_patches,
      };
    }

    case 'PRICE_PATCH_LIST_SUCCESS':
      return Object.assign({}, state, payload.entities && payload.entities.price_patches);
    default:
      return state;
  }
};

const initialState = {
  loading: false,
  errors: {},
};

const common = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'PRICE_PATCH_LIST_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'PRICE_PATCH_LIST_SUCCESS':
      return {
        ...state,
        loading: false,
      };
    case 'PRICE_PATCH_LIST_FAILURE':
      return {
        ...state,
        loading: false,
        errors: payload.errors,
      };
    default:
      return state;
  }
};

export default combineReducers({
  byId,
  common,
});

export const getList = state => mapObjectToList(state.byId);
export const getById = state => id => state.byId[id];



// WEBPACK FOOTER //
// ./client/app/reducers/price_patches.js